// ================================================================================
// script.js
// 案件用のスクリプトファイル
// ================================================================================

// DOM Read for Vanilla
// --------------------------------------------------------------- //

document.addEventListener('DOMContentLoaded', () => {

	// breakpoint
	const breakpoint = window.matchMedia( 'screen and (min-width: 960px)' )

	// scroll volume
	function getScrolled() {
		return ( window.pageYOffset !== undefined ) ? window.pageYOffset: document.documentElement.scrollTop;
	}



	// variable
	// --------------------------------------------------------------- //

	// scroll
	let scrollTop = window.pageYOffset

	// url
	let url = location.href



	// Header Fixed
	// --------------------------------------------------------------- //

	let startPos = 0;
	let header = document.getElementById('js-header');
	let triggerPos = 80;

	if ( header ) {
		if ( scrollTop < triggerPos ) {
			header.classList.remove('is-hidden')
			header.classList.remove('has-animation')
		} else {
			header.classList.add('has-animation')
		}
	}

	window.addEventListener('scroll', function(e) {
		let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
		let currentPos = scrollTop;

		if (currentPos > startPos) {
			// down
			if ( scrollTop >= triggerPos ) {
				header.classList.add('is-hidden')
				header.classList.add('has-animation')
			}
		} else {
			// up
			header.classList.remove('is-hidden')
			if ( scrollTop < triggerPos ) {
				header.classList.remove('has-animation')
			} else {
				header.classList.add('has-animation')
			}
		}
		startPos = currentPos;
	});



	// Dropdown for mobile
	// --------------------------------------------------------------- //

	const dropDownButton = document.getElementById('js-mobile-menu');
	const menuOpenTarget = document.querySelector('body');
	const dropdownTxt = document.getElementsByClassName('dropdown-text');

	if ( dropDownButton ) {
		dropDownButton.addEventListener('click', function() {
			dropDownButton.classList.toggle('is-close');
			menuOpenTarget.classList.toggle('is-menu-open');

			if (dropDownButton.classList.contains('is-close')) {
				dropdownTxt[0].textContent = 'CLOSE';
			} else {
				dropdownTxt[0].textContent = 'MENU';
			}
		});
	}

	// Dropdown for recruit
	// --------------------------------------------------------------- //

	const recruitDropdownButton = document.getElementById('js-recruit-menu');
	const recruitMenuList = document.querySelector('.recruit-menu-list');

	if (recruitDropdownButton && recruitMenuList) {
		recruitDropdownButton.addEventListener('click', function() {
			// ボタン自体のクラスをトグル
			recruitDropdownButton.classList.toggle('is-close');
			// recruit-menu-listにクラス"is-open"をトグル
			recruitMenuList.classList.toggle('is-open');
		});
	}

	// Accordion for sub-menu
	const navContainer = document.querySelector('.recruit-navigation-container');
	if (navContainer) {
	const siteBranding = document.querySelector('.site-branding.is-recruit');
	// navContainer の初期の縦方向の位置を取得
	const navOffsetTop = navContainer.offsetTop;

	window.addEventListener('scroll', function() {
		// 現在のスクロール位置が navContainer の位置以上になったら
		if (window.pageYOffset >= navOffsetTop) {
		navContainer.classList.add('is-fixed');
		siteBranding && siteBranding.classList.add('is-fixed');
		} else {
		navContainer.classList.remove('is-fixed');
		siteBranding && siteBranding.classList.remove('is-fixed');
		}
	});
	}

	// Accordion for sub-menu
	// --------------------------------------------------------------- //
	var menuToggleButtons = document.querySelectorAll('.js-sidebar-accordion');
	menuToggleButtons.forEach(function (button) {
		button.addEventListener('click', function () {
		var subMenu = this.nextElementSibling;
		// subMenuが存在するか確認
		if (subMenu && subMenu.classList.contains('sidebar-categories-list')) {
			subMenu.classList.toggle('is-open');
			// is-openクラスが付いたら高さを設定
			if (subMenu.classList.contains('is-open')) {
				subMenu.style.height = subMenu.scrollHeight + 'px';
			} else {
				subMenu.style.height = '0px';
			}
		}
		// buttonを使ってクラスis-openをトグル
		button.classList.toggle('is-open');
		});
	});


	// Fixedボタンのクローズを押したら変化するようにする
	document.querySelectorAll('.js-fixed-close').forEach(fixedBtn => {
		fixedBtn.addEventListener('click', function(){
		  const fixedArea = document.querySelector('.fixed-area');
		  if (fixedArea) {
			fixedArea.classList.add('is-close');
		  }
		});
	});


	// ajaxzipを使って郵便番号を入れたら自動で住所を入力させる
	const zip = document.querySelector('input[name="post-code"]');
	if (zip) {
		zip.setAttribute(
		'onkeyup',
		"AjaxZip3.zip2addr(this, '', 'address', 'address');"
		);
	}

	// フォームにあるプライバシーポリシーのチェックボックスをcheckするとボタンを押せるようにする
	const formCheck = document.querySelector('input[type="checkbox"]');
	const smfAction = document.querySelector('.smf-action');

	if (formCheck && smfAction) {
		// ページ読み込み時点の状態を反映
		smfAction.classList.toggle('is-active', formCheck.checked);

		// チェック状態が変わるたびにクラスを付け外し
		formCheck.addEventListener('change', () => {
		smfAction.classList.toggle('is-active', formCheck.checked);
		});
	}


	function setupEmailValidation(formId) {
		const form = document.getElementById(formId);
		if (form) {
			const emailInput = form.querySelector('input[name="email"]');
			const emailConfirmInput = form.querySelector('input[name="email-confirmation"]');
			const submitButton = form.querySelector('button[type="submit"]');

			// エラーメッセージ表示用の要素を作成
			const errorMessage = document.createElement('div');
			errorMessage.className = 'smf-error-messages';
			errorMessage.style.color = '#E60012';
			errorMessage.style.display = 'none';
			errorMessage.innerText = 'メールアドレスが一致しません。';
			emailConfirmInput.parentNode.appendChild(errorMessage);

			// 確認用メールアドレスフィールドの変更イベントリスナー
			emailConfirmInput.addEventListener('input', function() {
				if (emailInput.value !== emailConfirmInput.value) {
					errorMessage.style.display = 'block';
					submitButton.disabled = true;
				} else {
					errorMessage.style.display = 'none';
					submitButton.disabled = false;
				}
			});

			// フォーム送信時のイベントリスナー
			form.addEventListener('submit', function(event) {
				if (emailInput.value !== emailConfirmInput.value) {
					errorMessage.style.display = 'block';
					submitButton.disabled = true;
					event.preventDefault();
				} else {
					submitButton.disabled = false;
				}
			});
		}
	}

	// 各フォームに対してバリデーションを設定
	setupEmailValidation('snow-monkey-form-1078');
	setupEmailValidation('snow-monkey-form-1093');

} );






